import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppShell } from "../../components/Sidebar";
import { ModuleDetailBody } from "../../components/ModuleDetail";
import { api } from "../../lib/api";
import { ChevronLeft, Loader2, Play } from "lucide-react";

export default function StudentModuleDetail() {
  const { t, i18n } = useTranslation();
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const lang = i18n.resolvedLanguage || "en";
    api.get(`/modules/${moduleId}/details?lang=${lang}`).then((r) => setData(r.data));
  }, [moduleId, i18n.resolvedLanguage]);

  const recordContentView = (submoduleId) => {
    api.post("/student/content/view", { module_id: moduleId, submodule_id: submoduleId }).catch(() => {});
  };

  return (
    <AppShell role="student">
      <button
        onClick={() => navigate("/student/modules")}
        data-testid="back-to-modules"
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-600 hover:text-indigo-700"
      >
        <ChevronLeft size={14} /> {t("student.modules.title")}
      </button>

      {!data ? (
        <div className="mt-10 flex items-center justify-center"><Loader2 className="animate-spin text-indigo-600" /></div>
      ) : (
        <div className="mt-4">
          <ModuleDetailBody data={data} prefLangCode={i18n.resolvedLanguage || "en"} onContentView={recordContentView} />

          <div className="mt-6 flex justify-end">
            <button
              onClick={() => navigate(`/student/quiz/${moduleId}`)}
              data-testid="take-quiz-cta"
              className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow hover:bg-indigo-700"
            >
              <Play size={14} /> {t("student.quiz.start_quiz")}
            </button>
          </div>
        </div>
      )}
    </AppShell>
  );
}
